import dayjs from 'dayjs';

import {
  INDICATOR_GROUP_BY_TYPES_MAP,
  IndicatorAnalyzeRangeFilters,
} from 'business/shift-report/indicators/pages/indicator-analyze/providers/filters/types';
import { GetIndicatorAnalyzeV1ResponseDto } from 'generated/apiSchemas';
import { addMissingDaysForGraphPerDay } from 'technical/graph/add-missing-days-for-graph-per-day';
import { formatDateToDayAndMonth } from 'technical/time-utils/format-date-to-day-and-month';

export const GROUP_TYPE_TO_DATA_MAPPER = {
  [INDICATOR_GROUP_BY_TYPES_MAP.day]: (date: string | Date) =>
    formatDateToDayAndMonth(date),
  [INDICATOR_GROUP_BY_TYPES_MAP.week]: (date: string) =>
    dayjs(date).format('wo YYYY'),
  [INDICATOR_GROUP_BY_TYPES_MAP.month]: (date: string) =>
    dayjs(date).format('MMM YYYY'),
  [INDICATOR_GROUP_BY_TYPES_MAP.report]: (shift: string) => {
    const splitLabel = shift.split(' - ');
    return `${dayjs(splitLabel[0]).format('L')} - ${splitLabel[1]}`;
  },
};

export const formatData = (
  indicators:
    | GetIndicatorAnalyzeV1ResponseDto['values']['aggregated']
    | undefined,
  filters: IndicatorAnalyzeRangeFilters,
) => {
  const { filterType, groupByType } = filters;

  if (!indicators) {
    return [];
  }

  if (
    filterType === 'ring' ||
    groupByType === INDICATOR_GROUP_BY_TYPES_MAP.report
  ) {
    return indicators.sort((firstRing, secondRing) => {
      if (
        Number.isFinite(Number(firstRing.group)) &&
        Number.isFinite(Number(secondRing.group))
      ) {
        return Number(firstRing.group) - Number(secondRing.group);
      }
      return 0;
    });
  }

  if (
    filterType === 'date' &&
    groupByType === INDICATOR_GROUP_BY_TYPES_MAP.day
  ) {
    const filledGraphData = addMissingDaysForGraphPerDay(
      filters.dateRange,
      indicators.map(({ group, ...rest }) => ({
        date: dayjs(group).toDate(),
        ...rest,
      })),
      (date) => ({
        date: dayjs(date).toDate(),
      }),
    );

    return filledGraphData.map(({ date, ...rest }) => ({
      group: GROUP_TYPE_TO_DATA_MAPPER[INDICATOR_GROUP_BY_TYPES_MAP.day](date),
      ...rest,
    }));
  }

  return indicators.map(({ group, ...rest }) => ({
    group: GROUP_TYPE_TO_DATA_MAPPER[groupByType](group),
    ...rest,
  }));
};
